<template>
    <div class="layout-footer">
        <span>Copyright © {{ new Date().getFullYear() }}
            <RouterLink :to="{ name: 'dashboard' }">
                Imprion CRM Sales Portal</RouterLink>, All rights Reserved
        </span>
    </div>
</template>

<script setup lang="ts">
</script>
